import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {  message,Checkbox,Button,Menu, Dropdown,Timeline ,Popover,Collapse,Select,DatePicker,Modal,Input  } from 'antd';
import QRCode from "react-qr-code";
import {getData} from '../services/index';
import { BellOutlined, QrcodeOutlined,PlusOutlined,DownOutlined,CheckOutlined,DeleteOutlined,RetweetOutlined,FieldTimeOutlined, EyeOutlined,SafetyCertificateOutlined,EditOutlined,MoreOutlined,PrinterOutlined,FileExcelOutlined,MessageOutlined,DownloadOutlined,MailOutlined,ImportOutlined,ExportOutlined,UploadOutlined,MobileOutlined,FilterOutlined } from '@ant-design/icons';
import Pagination from "react-js-pagination";

import { Drawer,Popconfirm } from 'antd';

import DatePickers from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
 import axios from 'axios';

import $ from 'jquery';
const CheckboxGroup = Checkbox.Group;

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;
function callback(key) {
  console.log(key);
}

const plainOptions = ['Apple', 'Pear', 'Orange'];
const defaultCheckedList = ['Apple', 'Orange'];


function disabledDate(current) {
  // Can not select days before today and today
   return current && current > moment().endOf('day');
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			followup_date: new Date(),
			import_loading:false,
			csv_file:null,
			import_visible:false,
			msg: '',
			school_id: '',
			sms_text:'',
			email_subject:'',
			email_body:'',
			selection_count:0,
			sms_visible:false,
			email_visible:false,
			qr_visible:false,
			filter_visible:false,
			checkedBoxes: [],
			school_list : [],
			enquiry_list : [],
			timeline_details : [],
			marketing_followup_details : [],
			enquiries_details : [],
			fees_setting : [],
			academic_year_ : [],
			index:0,
			visible: false,
			followup: false,
			addfollow: false,
			status_view: false,
			fees_view: false,
			timeline: false,
			checkAll: false,
			mobile_sms: false,
			mobile_follow: false,
			checkedList: defaultCheckedList,
			checked: false,
			enquiry_id:0,
			currentDate:'',
			assign_label:'',
			source:'',
			academic_year:'',
			date:'',
			keyword:'',
			qr_link:'',
			program_id:'',
			page: 1,
			total_count:0,
			tag_name:[],
			staff_list:[],
			manage_class:[],
		}
		this.handleSizeChange = this.handleSizeChange.bind(this);
		this.onChangedate = this.onChangedate.bind(this);	
		this.onChangePage = this.onChangePage.bind(this);	
	}
	
	onChangePage=(pageNumber)=>{
	    this.setState({ page : pageNumber });
	    setTimeout(() => {
		 this.checkData();
	    }, 500);
	}
	
	onChangedate(date, dateString) {
	  this.setState({ date: dateString });
		;
	}
	

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			this.setState({ user_id : storedArray['data'][0]['user_id'],school_id:storedArray['data'][0]['school_id'],user_type:storedArray['data'][0]['type'] });
		}
		this.checkData();
	}
	
	
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app_ = {
				user_id : user_id,
				school_id:school_id,
				date:this.state.date,
				page:this.state.page,
			}
			getData('erp/today_report',app_).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							total_school: result['total_count'],
							total_count: result['total_count'],
						});
					}else{
						this.setState({
							school_list: [],
							
						});
					}
				}
			});
		}
	}
	
	handleSearch=(e)=>{
		setTimeout(() => {
			this.setState({ page: 1 });
			this.checkData();
		}, 300);
	}
	
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
		
	};
   
   
    toggleChecked = () => {
		const checkedBoxes = [...this.state.checkedBoxes];
		var checkboxes = document.getElementsByName('checked_id[]');
		for (var i = 0; i < checkboxes.length; i++) {
			checkedBoxes.push(checkboxes[i].value);	
		}
		this.setState({checkedBoxes,checked:true});
    }
	
	toggleUnChecked = () => {
		this.setState({checkedBoxes:[],checked:false});
    }
  
	handleCheckbox = (e, s) => {
		const checkedBoxes = [...this.state.checkedBoxes];
		if(e.target.checked) {
			checkedBoxes.push(s)
		} else {
			const index = checkedBoxes.findIndex((ch) => ch === s);
			checkedBoxes.splice(index, 1);
		}
		this.setState({checkedBoxes,selection_count:checkedBoxes.length});
	}
  
	
	
	

	render() {
	
	 
	

		return (
				<>
				<div class="mobile_view">
				<div class="row bred">
					<div class="col-md-12">
					<div class="card">
					<div class="card-body">
						<h4 class="page-title"> 
							<i class="mdi mdi-apple-keyboard-command title_icon"></i> Today Report
							
							<div class="breadcrumb-wrapper">
								<ol class="breadcrumb">
									<li class="breadcrumb-item">
										<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
										<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
										</a>
									</li>
									<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/enquiries`} class="router-link-active" target="_self">Enquiries</a> </li>
									<li class="breadcrumb-item">  Today Report</li>
								</ol>
							</div>
						</h4>
					</div>
					</div>
					</div>
				</div>
				</div>
				
				
				<div class="">
				  <div class="card">
					<div class="card-body">
						
						<div class="row">
						
												
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Date</b></label>
								 <DatePicker  onChange={this.onChangedate} disabledDate={disabledDate}/>
							</div>
						</div>
						
						
						
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}>&nbsp;</label>
								 <Button className="btn btn-primary mr-2" style={{display: 'block'}} id="submit_btn" onClick={this.handleSearch.bind(this)} >Apply</Button>
							</div>
						</div>
						</div>
				  </div>
				  </div>
               </div>
			  
			   
			    <div class="">
                  <div class="row">
                     <div class="col-lg-12 mb-3">
					 <div class="card">
						<div class="card-body">
						
						<div class="row mb-10">
						<div class="col-sm-4 col-12 text-left  enquiry-btn mt-10">
							<h4 class="header-title mt-5px">Total Staff : {this.state.total_count}</h4>
						</div>
						</div>
                        <div class="table-responsive">
                           <table class="table table-striped table-bordered table-hover">
                              <thead>
                                 <tr>
                                    <th>#</th>
                                    <th>Staff Name</th>
									<th>Total Enquiries</th>
									<th>Move To Process Admission</th>
									<th>Approved To Admission</th>
                                 </tr>
                              </thead>
                              <tbody>
							  {this.state.school_list.length == 0 && (<><tr><td colspan="11" class="text-center">No Enquiry Found</td></tr></>)}
							  {this.state.school_list.map((list,index) => (
                                 <tr>
                                    <td>{index+1}</td>
                                    <td>{list.staff_name}
									<span class="d-block">{list.staff_email}</span>
									</td>
                                    <td>{list.enquiries}</td>
                                    <td>{list.process}</td>
                                    <td>{list.admission}</td>
                                 </tr>
								 ))}
                                
                              </tbody>
                           </table>
                        </div>
						<div class="fl-right">
			<Pagination
				activePage={this.state.page}
				itemsCountPerPage={10}
				totalItemsCount={this.state.total_count}
				pageRangeDisplayed={3}
				onChange={this.onChangePage.bind(this)}
			/>
		</div>
			
                        </div>
                        </div>
						
				
						
                     </div>
                  </div>
               </div>
               
			   
			   
			
			
				
				
				
				
			   
			
			
			</>
		) 
	} 
}
export default Index;
